import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './app/App';
import * as serviceWorker from './serviceWorker';
import {BrowserRouter} from 'react-router-dom';
import * as Sentry from "@sentry/react";
import {Integrations} from "@sentry/tracing";

var version;

fetch("/config")
    .then(response => response.json())
    .then(config => {
        Sentry.init({
            dsn: 'https://8f85311b49e048d3832ab6e93cf63835@o30372.ingest.sentry.io/5439550',
            integrations: [
                new Integrations.BrowserTracing(),
            ],
            tracesSampleRate: 1.0,
            release: config.VERSION,
            environment: config.ENV
        });
        version = config.VERSION;
    });

setInterval(() => {
    fetch("/config")
        .then(response => response.json())
        .then(config => {
            if(!version) version = config.VERSION;
            else if(config.VERSION !== version) {
                window.location.reload();
            }
        });
}, 60*60*1000);

ReactDOM.render(
    <React.StrictMode>
        <BrowserRouter>
            <App />
        </BrowserRouter>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
